module.exports = __webpack_public_path__ + "img/bengfang.3e031296.png";